import { render, staticRenderFns } from "./DeleteMaintenanceAnnouncement.vue?vue&type=template&id=d7b08d7c"
import script from "./DeleteMaintenanceAnnouncement.vue?vue&type=script&lang=js"
export * from "./DeleteMaintenanceAnnouncement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports